import type { GasStationResponseDto } from "@pro-sto/api-client";

export const VIEWPORT_BUFFER_RATIO = 0.3;

export interface MapBounds {
  north: number;
  south: number;
  east: number;
  west: number;
}

export interface ReadableMapBounds {
  getNorth(): number;
  getSouth(): number;
  getEast(): number;
  getWest(): number;
}

export function expandMapBounds(
  bounds: ReadableMapBounds,
  bufferRatio = VIEWPORT_BUFFER_RATIO,
): MapBounds {
  const latSpan = bounds.getNorth() - bounds.getSouth();
  const lngSpan = bounds.getEast() - bounds.getWest();
  const latPad = (latSpan * bufferRatio) / 2;
  const lngPad = (lngSpan * bufferRatio) / 2;

  return {
    north: bounds.getNorth() + latPad,
    south: bounds.getSouth() - latPad,
    east: bounds.getEast() + lngPad,
    west: bounds.getWest() - lngPad,
  };
}

export function isCoordInBounds(
  lat: number,
  lon: number,
  bounds: MapBounds,
): boolean {
  if (lat < bounds.south || lat > bounds.north) {
    return false;
  }

  if (bounds.west <= bounds.east) {
    return lon >= bounds.west && lon <= bounds.east;
  }

  return lon >= bounds.west || lon <= bounds.east;
}

export function filterStationsInMapBounds(
  stations: GasStationResponseDto[],
  bounds: MapBounds,
  getCoords: (station: GasStationResponseDto) => [number, number] | null,
): GasStationResponseDto[] {
  return stations.filter((station) => {
    const coords = getCoords(station);
    if (!coords) return false;
    return isCoordInBounds(coords[0], coords[1], bounds);
  });
}
